import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';

@Component({
    selector: 'app-footer-vertical-step',
    standalone: true,
    imports: [CommonModule, TranslateModule],
    templateUrl: './footer-vertical-step.component.html',
    styleUrl: './footer-vertical-step.component.scss',
})
export class FooterVerticalStepComponent {
    financing = 'core.components.stepper.footerVerticalStep.financing';
    cetelem = 'core.components.stepper.footerVerticalStep.cetelem';
    cookiesPolicy = 'core.components.stepper.footerVerticalStep.cookiesPolicy';
    legalInformation = 'core.components.stepper.footerVerticalStep.legalInformation';
    dataProtection = 'core.components.stepper.footerVerticalStep.dataProtection';
    publicInformation = 'core.components.stepper.footerVerticalStep.publicInformation';
    exitStore = 'core.components.stepper.footerVerticalStep.exitStore';
}
